// extracted by mini-css-extract-plugin
export default {"root":"SpinnerSimple_root__hD-xq","spinner":"SpinnerSimple_spinner__IXFrn","infinite-spinner":"SpinnerSimple_infinite-spinner__46QbP"};